export default __webpack_public_path__ + "assets/images/9d4eae8c8981ea170c12afc1978a1728.svg";